import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ApprovalHistory } from '@webapp/models/ApprovalHistory'
import { LoggerActions } from '@webapp/models/enums'
import { UserMock } from './user.factory'

export const ApprovalHistoryMock = Factory.Sync.makeFactory<ApprovalHistory>({
  id: Factory.each(() => faker.random.number()),
  user: Factory.each(() => UserMock.build()),
  next_approver: Factory.each(() => UserMock.build()),
  nextApprover: Factory.each(() => UserMock.build()),
  dateTime: Factory.each(() => faker.date.past().toISOString()),
  action: LoggerActions.REQUEST,
  order: Factory.each(() => faker.random.number()),
})
